// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2133":"b8d6a1f8e1c1b1dc","5036":"17a2a01e5c9d9beb"}[chunkId] + ".js";
};